export enum SnippetsApi {
  Snippets = '/api/v1.0/snippets/user',
  CompanySnippets = '/api/v1.0/users/teamsnippets',
  CreateSnippet = '/api/v1.0/snippets/user',
  UpdateSnippets = '/api/v1.0/snippets/user',
  DeleteSnippets = '/api/v1.0/snippets/user'
}
